export enum SessionType {
  Desktop = 'desktop',
  Mobile = 'mobile',
}
